import { graphql } from 'react-relay';
import type { GraphQLTaggedNode } from 'relay-runtime';

export const useAgentSessionsLiveUpdatesSubscription: GraphQLTaggedNode = graphql`
	subscription useAgentSessionsLiveUpdatesSubscription(
		$accountId: String!
		$cloudId: ID!
		$workspaceAri: ID!
		$conversationWorkspaceAri: String!
	) {
		convoai_onInboxSessionChanged(
			accountId: $accountId
			cloudId: $cloudId
			workspaceAri: $workspaceAri
		) @optIn(to: "ConvoAiInboxSessionChanged") {
			sessionAri
			sessionId
			session {
				__typename
				id
				state
				stateReason
				expireTime
				lastStateChangeAt
				isRovo
				agentAccountId
				convoAiAgentId
				conversationChannel(workspaceAri: $conversationWorkspaceAri)
					@optIn(to: ["AgentConversationChannelTeamEu26DemoOnly"]) {
					__typename
					id
					name
					readStatus
				}
			}
		}
	}
`;
